var paywall = require("./lib/paywall");
setTimeout(() => paywall(13809623), 5000);

require("component-responsive-frame/child");


var width = Math.max(
    document.documentElement["clientWidth"],
    document.body["scrollWidth"],
    document.documentElement["scrollWidth"],
    document.body["offsetWidth"],
    document.documentElement["offsetWidth"]
);

var quote = ((width / 2) - 80) * (5/7);



// document.querySelectorAll(".box .quote").forEach(el => {
//     el.style.height = `${quote}px`;
// });

function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}


docReady(function() {
    // DOM is loaded and ready for manipulation here
    var runSizeFunc = function() {
    var w = 0;

    if(width > 800){

    document.querySelectorAll(".box .vert .photo").forEach(el => {
      w = (el.clientHeight > 0) ? el.clientHeight * (5/7) : w;
      // console.log(el.clientHeight);
      // console.log(Math.max(document.documentElement.clientHeight, window.innerHeight || 0));
    });



    // document.querySelectorAll(".box .quote.hor").forEach(el => {
    //     // el.style.width = `${w}px`;
    //     var height = (w * (5/7));
    //     // el.style.height = width > 500 ? `${height}px` : '100vh';
    // });






      document.querySelectorAll(".box .quote").forEach(el => {
          el.style.width = `${w}px`;
          // var height = (w * (5/7));
          // el.style.height = `${height - 40}px`;
      });

      document.querySelectorAll(".box .hor .photo").forEach(el => {
          el.style.width = `${w}px`;
          // var height = (w * (5/7));
          // el.style.height = `${height}px`;
      });

      document.querySelectorAll(".box .vert .photo").forEach(el => {
          el.style.width = `${w}px`;
          // var height = (w * (5/7));
          // el.style.height = `${height}px`;
      });

      document.querySelectorAll(".box .hor-vert .photo").forEach(el => {
          el.style.width = `${w}px`;
          // var height = (w * (5/7));
          // el.style.height = `${height}px`;
      });

      document.querySelectorAll(".middle .hor-vert .photo").forEach(el => {
          el.style.width = `${w * 2}px`;
          // var height = (w * (5/7));
          // el.style.height = `${height}px`;
      });

      document.querySelectorAll(".middle .hor .quote").forEach(el => {
          el.style.width = `${w * 2}px`;
          // var height = (w * (5/7));
          // el.style.height = `${height}px`;
      });
    }
    console.log(w);
  }

  // runSizeFunc();

  window.addEventListener("resize", runSizeFunc());

});
